import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { loan_application } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { useWatch } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../../utils/format';
import type { PartnerFormGroupData } from '../../../FormData.dk.types';
import { maritalStatusOptions } from '../../../config/globals';
import { requiredField } from '../../shared-config';
import { partnerNetIncomeMonthlyFieldOptions } from './config';

export function PartnerFormGroup() {
  const { t } = useTranslation();

  const maritalStatus = useWatch({ name: 'LoanApplication/MaritalStatus' });

  const requirePartnerIncome =
    maritalStatus && maritalStatus !== loan_application.MaritalStatus.Single;

  return (
    <>
      <RadioFieldUI<PartnerFormGroupData>
        name="LoanApplication/MaritalStatus"
        label={t('MaritalStatus.label')}
        data-testid="marital-status-radio"
        radioStyle="button"
        options={maritalStatusOptions}
        registerOptions={requiredField}
      />

      {requirePartnerIncome && (
        <NumberFieldUI<PartnerFormGroupData>
          name="Frontend/PartnerNetIncomeMonthly"
          label={t('PartnerNetIncomeMonthly.label')}
          data-testid="partner-net-income-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...partnerNetIncomeMonthlyFieldOptions}
        />
      )}
    </>
  );
}
